export default {
  routingMethodHeader: "طريقة التوجيه",
  routingMethodContent: "إختر طريقة التوجيه المناسبة لتلقى الطلبات لتجربة أفضل",
  standAloneHeader: " التابليت المنفصل",
  standAloneContent: "كل فرع سوف يعمل على تابلت كوينز منفصل",
  callCenterHeader: "خدمة العملاء",
  callCenterContent: "خدمة عملائكم سيقومون بتلقي الطلبات والتحكم فيها",
};
